var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPluscircleblack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000003757"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 27",
    cx: 17,
    cy: 17,
    r: 17,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1000003755"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17 25C16.7348 25 16.4804 24.9177 16.2929 24.7712C16.1054 24.6247 16 24.426 16 24.2188V9.78125C16 9.57405 16.1054 9.37534 16.2929 9.22882C16.4804 9.08231 16.7348 9 17 9C17.2652 9 17.5196 9.08231 17.7071 9.22882C17.8946 9.37534 18 9.57405 18 9.78125V24.2188C18 24.426 17.8946 24.6247 17.7071 24.7712C17.5196 24.9177 17.2652 25 17 25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M24.2188 18H9.78125C9.57405 18 9.37534 17.8946 9.22882 17.7071C9.08231 17.5196 9 17.2652 9 17C9 16.7348 9.08231 16.4804 9.22882 16.2929C9.37534 16.1054 9.57405 16 9.78125 16H24.2188C24.426 16 24.6247 16.1054 24.7712 16.2929C24.9177 16.4804 25 16.7348 25 17C25 17.2652 24.9177 17.5196 24.7712 17.7071C24.6247 17.8946 24.426 18 24.2188 18Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPluscircleblack);
export default __webpack_public_path__ + "static/media/pluscircleblack.908aef75ffcf84b2fc71494e1fc94db7.svg";
export { ForwardRef as ReactComponent };